// extracted by mini-css-extract-plugin
module.exports = {"nav":"Nav_nav__1GIM8"};